document.addEventListener('DOMContentLoaded', function () {

  // Swatch workaround
  // ignore web safe color names (which works out of box),
  // but for non-standard colors apply value from the array

  const gbjjSwatches = {
    'aqua-triblend': '#00BFA5',
    'athletic-heather': '#C1C1C1',
    'berry': '#B03060',
    'berry-triblend': '#8E4585',
    'brown-triblend': '#5C4033',
    'charcoal-black-triblend': '#3A3A3A',
    'charcoal-heather': '#4B4F54',
    'clay-triblend': '#B66A50',
    'collegiate-royal': '#2B5CAA',
    'dark-grey-heather': '#6E6E6E',
    'emerald-triblend': '#046A38',
    'forest': '#228B22',
    'grey-triblend': '#B0B0B0',
    'heather-forest': '#4C7554',
    'kelly': '#4CBB17',
    'maroon-triblend': '#800000',
    'mustard': '#FFDB58',
    'mustard-triblend': '#D4AF37',
    'navy-blazer': '#1A1F2B',
    'navy-triblend': '#1A237E',
    'olive-triblend': '#708238',
    'purple-triblend': '#6A0DAD',
    'red-triblend': '#C62828',
    'solid-black-triblend': '#000000',
    'teal-triblend': '#008080',
    'true-royal': '#3F51B5',
    'true-royal-triblend': '#3F51B5'
  };

  const webColorNames = new Set([
    "aliceblue","antiquewhite","aqua","aquamarine","azure","beige","bisque","black","blanchedalmond","blue","blueviolet",
    "brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan",
    "darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkgrey","darkkhaki","darkmagenta","darkolivegreen",
    "darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkslategrey",
    "darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dimgrey","dodgerblue","firebrick","floralwhite",
    "forestgreen","fuchsia","gainsboro","ghostwhite","gold","goldenrod","gray","green","greenyellow","grey","honeydew",
    "hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue",
    "lightcoral","lightcyan","lightgoldenrodyellow","lightgray","lightgreen","lightgrey","lightpink","lightsalmon",
    "lightseagreen","lightskyblue","lightslategray","lightslategrey","lightsteelblue","lightyellow","lime","limegreen",
    "linen","magenta","maroon","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen",
    "mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose",
    "moccasin","navajowhite","navy","oldlace","olive","olivedrab","orange","orangered","orchid","palegoldenrod",
    "palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","purple",
    "rebeccapurple","red","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna",
    "silver","skyblue","slateblue","slategray","slategrey","snow","springgreen","steelblue","tan","teal","thistle",
    "tomato","turquoise","violet","wheat","white","whitesmoke","yellow","yellowgreen"
  ]);

  // Swatches: intervention on individual product page
  document
    .querySelectorAll('label.radio-option-swatch-circle__label')
    .forEach(label => {
      const swatchColor = getComputedStyle(label)
        .getPropertyValue('--swatch-color')
        .trim()
        .toLowerCase();

      if (!webColorNames.has(swatchColor)) {
        const span = label.querySelector('span');
        if (span && span.textContent.trim()) {
          const fallback = span.textContent.trim().toLowerCase().replace(/\s+/g, '-');
          if (typeof gbjjSwatches[fallback] !== 'undefined') {
            label.style.setProperty('--swatch-color', gbjjSwatches[fallback]);
          } else {
            console.log('### missing swatch: ' + fallback);
          }
        }
      }
    });

  // Swatches: intervention on product card loop
  document
    .querySelectorAll('button.product-card__swatch-button')
    .forEach(button => {
      const swatchColor = getComputedStyle(button)
        .getPropertyValue('--swatch-color')
        .trim()
        .toLowerCase();

      if (!webColorNames.has(swatchColor)) {
        const dataSwatch = button.getAttribute('data-swatch');
        if (dataSwatch && dataSwatch.trim()) {
          const fallback = dataSwatch.trim().toLowerCase().replace(/\s+/g, '-');
          if (typeof gbjjSwatches[fallback] !== 'undefined') {
            button.style.setProperty('--swatch-color', gbjjSwatches[fallback]);
          } else {
            console.log('### missing swatch (button): ' + fallback);
          }
        }
      }
    });

  // Scheduler: open current day schedule on homepage
  const adjustedDay = (new Date().getDay() + 6) % 7;
  const scheduleItems = document.querySelectorAll(
    'body.template-index .faq-simple__item-control'
  );
  if (scheduleItems[adjustedDay]) {
    scheduleItems[adjustedDay].click();
  }

  // Hide recommendations if contains dummy data
  const section = document.querySelector('section.product-recommendations');
  if (section) {
    const matchingLinks = Array.from(
      section.querySelectorAll('a.product-card__title')
    ).filter(a => a.textContent.trim() === 'Product title');

    if (matchingLinks.length === 4) {
      section.style.display = 'none';
    }
  }

  // Zen page activate icons
  document
    .querySelectorAll(
      '#shopify-section-template--24833325760759__benefits_f3pMRb li.benefits__col'
    )
    .forEach(li => {
      const link = li.querySelector('a');
      if (!link) return;

      const href = link.getAttribute('href');
      link.remove();

      const img = li.querySelector('img.benefits__icon');
      if (img) {
        const newLink = document.createElement('a');
        newLink.setAttribute('href', href);
        img.parentNode.insertBefore(newLink, img);
        newLink.appendChild(img);
      }
    });

});
